<template>
  <div class="full-height">
    <migration-manager
      v-if="clientPortal.portal != '3' && isAdmin()"
      :client-portal="clientPortal"
    ></migration-manager>
    <v-row style="height: calc(100% + 12px)">
      <v-col
        cols="12"
        md="9"
        class="full-height thin-scroll"
        style="overflow-y: auto"
      >
        <v-row style="height: calc(100% + 12px)">
          <v-col cols="12" md="6">
            <portal-summary-card
              :client-portal="clientPortal"
            ></portal-summary-card>
          </v-col>
          <v-col cols="12" md="6">
            <portal-presentation-summary-card
              :client-portal="clientPortal"
            ></portal-presentation-summary-card>
            <smac-card :client-portal-id="clientPortal.id"></smac-card>
          </v-col>
          <v-col cols="12" class="py-0">
            <nas-card
              :clientPortal="clientPortal"
              :fixedHeaders="false"
              :hide-create-button="true"
            ></nas-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="3" class="full-height">
        <portal-notes-manager
          :client-portal="clientPortal"
        ></portal-notes-manager>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { defineComponent, toRefs, onMounted } from "@vue/composition-api";
import { useClientPortal } from "@/composables/client-portal";
import { date } from "@/composables/date";
import NasCard from "@/components/ClientPortal/NasCard";
import SmacCard from "@/components/ClientPortal/SmacCard.vue";
import MigrationManager from "@/components/ClientPortal/MigrationManager.vue";
import PortalSummaryCard from "@/components/ClientPortal/PortalSummaryCard.vue";
import PortalPresentationSummaryCard from "@/components/ClientPortal/PortalPresentationSummaryCard.vue";
import PortalNotesManager from "@/components/ClientPortal/PortalNotesManager.vue";
import { useRoles } from "../../composables/roles";

export default defineComponent({
  components: {
    NasCard,
    SmacCard,
    MigrationManager,
    PortalSummaryCard,
    PortalPresentationSummaryCard,
    PortalNotesManager,
  },
  props: {
    clientPortal: {
      type: Object,
      required: true,
    },
  },
  setup() {
    /* Import des API */
    const { data } = useClientPortal();
    const { getInternationalDate } = date();
    const { isAdmin } = useRoles();

    /* Cycle de vie */
    onMounted(() => {});

    /* Variables */

    /* Méthodes */

    /* Watchers */

    return {
      ...toRefs(data),
      getInternationalDate,
      isAdmin,
    };
  },
});
</script>
